import { useI18n } from 'vue-i18n'
import axios from 'axios'
import download from 'downloadjs'
import { notify } from '@kyvg/vue3-notification'
import { ref } from 'vue'

/**
 * Generic file downloader composable.
 */
export function useFileDownloader() {
    const { t } = useI18n()
    const downloading = ref(false)

    async function downloadBlobFile(fileUrl: string, fileType: string) {
        const response = await axios.get(fileUrl, {
            responseType: 'blob',
            withCredentials: false,
        })

        const filename = fileUrl.split('/').pop() || `download.${fileType.split('/')[1] || 'bin'}`

        download(response.data, filename, fileType)
    }

    return {
        downloading,
        downloadFile: async function (url: string, fileType = 'application/pdf') {
            try {
                downloading.value = true

                const { data } = await axios.get(url)
                if (data.s3Url) {
                    // Case 1: Response is a JSON with s3Url (application/json)
                    await downloadBlobFile(data.s3Url, fileType)
                } else if (!data.s3Url) {
                    // Case 2: Response is a file (Blob)
                    await downloadBlobFile(url, fileType)
                } else {
                    throw new Error('Unexpected response: expected a Blob or an object with s3Url')
                }

                notify({ type: 'success', text: t('fileDownloadedSuccessfully') })
            } catch (error) {
                notify({ type: 'error', text: t('fileDownloadFailed') })
            } finally {
                downloading.value = false
            }
        },
    }
}
